import { IAppStore } from './types';

const initStore: IAppStore = {
  sidebarMenuOpened: false,
};

export default initStore;
